/**
 * Hook to access Getty vocabulary favorites.
 */

import { useContext } from 'react';
import { GettyFavoritesContext } from '../contexts/GettyFavoritesContext';

export const useGettyFavorites = () => {
  const context = useContext(GettyFavoritesContext);
  if (context === undefined) {
    throw new Error('useGettyFavorites must be used within a GettyFavoritesProvider');
  }
  return context;
};
